import { Controller } from "@hotwired/stimulus"

// Generic "add another" / "remove" controller for Rails nested attribute
// forms (e.g. product variants, purchase order items). Pairs with a
// <template data-nested-form-target="template"> containing fields_for
// markup built with child_index: "NEW_RECORD".
export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const item = event.target.closest(".nested-fields")
    const destroyField = item.querySelector("input[name$='[_destroy]']")

    if (destroyField) {
      destroyField.value = "1"
      item.classList.add("d-none")
    } else {
      item.remove()
    }
  }
}
